import React from "react";
import { Link } from "react-router-dom";

const Footer = ({practiceData}) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center text-gray-500 text-sm mt-auto p-4">
      <p>© {currentYear} <Link to="#" className="text-green-600">{practiceData?.alt_account_name ? practiceData?.alt_account_name : practiceData?.account_name}</Link>. All Rights Reserved.</p>
      {/* <p>
        <Link to="#" className="text-green-600 hover:underline">Privacy Policy</Link>&nbsp;/&nbsp;
        <Link to="#" className="text-green-600 hover:underline">Terms and Conditions</Link>
      </p> */}
    </footer>
  );
};

export default Footer;
